import { formatTracePayload } from './formatTracePayload.js'
import TraceCopyButton from './TraceCopyButton.jsx'
import PayloadBoxBody from './PayloadBoxBody.jsx'
import styles from './AIResponseLog.module.scss'

/**
 * @param {{ payload?: string | Record<string, unknown> }} props
 */
export default function ArgumentsBox({ payload }) {
  const text = formatTracePayload(payload)
  if (!text.trim()) return null

  return (
    <div className={styles.payloadSection}>
      <div className={styles.payloadHeader}>
        <span className={styles.payloadLabel}>Arguments:</span>
        <TraceCopyButton text={text} label="Copy arguments" />
      </div>
      <PayloadBoxBody text={text} />
    </div>
  )
}
